import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Facebook, Linkedin, Instagram, User } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src="/images/logo.png" 
                alt="DC Men in ECE Logo" 
                className="h-16 w-auto object-contain bg-white rounded-lg p-2"
              />
            </Link>
            <p className="text-navy-300 text-sm leading-relaxed mb-6">
              Transforming early childhood education in D.C. by supporting men in ECE with a focus on equity, inclusion, comradeship and professional development.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/DCMenInECE" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-navy-800 hover:bg-brand-green flex items-center justify-center transition-colors duration-300" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/dc-men-in-ece/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-navy-800 hover:bg-brand-green flex items-center justify-center transition-colors duration-300" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/dcmeninece/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-navy-800 hover:bg-brand-green flex items-center justify-center transition-colors duration-300" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">About Us</Link></li>
              <li><Link to="/mission" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Mission & Vision</Link></li>
              <li><Link to="/membership" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Membership</Link></li>
              <li><Link to="/conference" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Conference</Link></li>
              <li><Link to="/contact" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Member Access */}
          <div>
            <h4 className="font-semibold text-white mb-6">Member Access</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/member-login" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm inline-flex items-center gap-2">
                  <User className="w-4 h-4" />
                  Member Login
                </Link>
              </li>
              <li><Link to="/join" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Join Us</Link></li>
              <li><Link to="/events" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">Events</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-brand-gold mt-0.5 flex-shrink-0" />
                <a href="mailto:dcmeninece@gmail.com" className="text-navy-300 hover:text-brand-gold transition-colors duration-200 text-sm">
                  dcmeninece@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-gold mt-0.5 flex-shrink-0" />
                <span className="text-navy-300 text-sm">Washington, D.C.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-navy-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-navy-400 text-sm">
              © {new Date().getFullYear()} DC Men in Early Childhood Education. All rights reserved.
            </p>
            <p className="text-navy-400 text-sm">
              An initiative of the DC Early Learning Collaborative
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
